var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25 14c-3.859 0-7 3.589-7 8 0 3.177 1.634 5.92 3.987 7.21l-.987 17.79c0 2.206 1.794 4 4 4s4-1.794 3.998-4.056l-.985-17.734c2.354-1.29 3.987-4.033 3.987-7.21 0-4.411-3.141-8-7-8zm2 33c0 1.103-.897 2-2 2s-2-.897-2.002-1.944l.953-17.156c.343.059.692.1 1.049.1s.706-.041 1.049-.1zm-2-19c-2.757 0-5-2.691-5-6s2.243-6 5-6 5 2.691 5 6-2.243 6-5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.989 29.181-.989 17.819c0 2.206 1.794 4 4 4s4-1.794 3.998-4.056l-.987-17.763c1.784-1.041 2.989-2.971 2.989-5.181v-10h-2v8h-3v-8h-2v8h-3v-8h-2v10c0 2.211 1.205 4.14 2.989 5.181zm5.011 17.819c0 1.103-.897 2-2 2s-2-.897-2.002-1.944l.953-17.154c.341.061.691.098 1.049.098s.708-.037 1.049-.098zm2-23c0 2.206-1.794 4-4 4s-4-1.794-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 1c-17.094 0-31 13.907-31 31 0 17.094 13.906 31 31 31s31-13.906 31-31c0-17.093-13.906-31-31-31zm0 60c-15.99 0-29-13.01-29-29 0-15.991 13.01-29 29-29s29 13.009 29 29c0 15.99-13.01 29-29 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 32c0 13.785-11.215 25-25 25v2c14.888 0 27-12.112 27-27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 5c-14.888 0-27 12.112-27 27h2c0-13.785 11.215-25 25-25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.4b700c2aedc98ff70ecc3c5704f75e3a.svg";
export { ForwardRef as ReactComponent };